import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { v1 } from 'uuid';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import secteurProp from 'components/propTypes/secteur';
import exploitationProp from 'components/propTypes/exploitation';
import SearchBar from 'components/generics/SearchBar';
import { SimulationContext } from 'components/pages/Exploitation/SimulationContext';
import { ExploitationContext, LoadingContext } from 'utils/context';
import { getSecteurList } from 'services/API/Cooperative';
import { useTranslation } from 'react-i18next';

const ExploitationHome = ({ setExploitation, exploitation = {}, cooperativeId }) => {
  const [input, setInput] = useState('');
  const navigate = useNavigate();
  const [secteursDefault, setSecteursDefault] = useState([]);
  const [secteursFiltered, setSecteursFiltered] = useState([]);
  const { setSimulationContext } = React.useContext(SimulationContext);
  const { setFullScreen } = useContext(LoadingContext);
  const { setGroundTypesList } = useContext(ExploitationContext);
  const { t } = useTranslation();

  /**
   * Filter on exploitation for secteurs
   * @param arr
   * @param fiterText
   * @returns
   */
  function filterExploitation(arr, fiterText) {
    const rows = [];
    arr.forEach((secteur) => {
      const filteredExp = secteur.exploitations.filter((exp) => {
        return exp.name.toLowerCase().includes(fiterText.toLowerCase());
      });

      if (filteredExp.length > 0) {
        rows.push({ id: secteur.id, name: secteur.name, exploitations: filteredExp });
      }
    });
    return rows;
  }

  useEffect(() => {
    getSecteurList(cooperativeId)
      .then((resp) => {
        setSecteursDefault(resp.data.data);
        setSecteursFiltered(resp.data.data);
      })
      .catch((err) => {
        toast.error(t('errors.ERR_GET_EXPLOITATIONS_LIST'));
      });
  }, []);

  /**
   * Update filtered exploitations
   * @param input
   */
  const updateInput = async (input) => {
    const filtered = filterExploitation(secteursDefault, input.target.value);
    setInput(input);
    setSecteursFiltered(filtered);
  };

  return (
    <div className="Content">
      <div className="Exploitation">
        <div className="searchbar_align">
          <SearchBar
            defaultStyle="searchbar"
            className="primary"
            input={input}
            onChange={updateInput}
            placeholder={t('placeholder.searchExploitation')}
          />
        </div>

        {secteursFiltered.map((secteur) => (
          <div key={v1()}>
            <h2 className="title">{secteur.name}</h2>
            <div className="containerGrid">
              {secteur.exploitations.map((exp) => (
                <div
                  key={v1()}
                  onClick={() => {
                    setFullScreen(true);
                    setSimulationContext();
                    setGroundTypesList([]);
                    setExploitation(false, exp.id)
                      .then((resp) => {
                        localStorage.setItem('exploitation', exp.id);
                        toast.success(t('success.itemSelected', { name: exp.name }));
                        navigate('/exploitation/parcels', {
                          state: {
                            exploitContextReloadNeeded: false,
                          },
                        });
                      })
                      .finally(() => setFullScreen(false));
                  }}
                  className={`itemGrid${exp.id === exploitation?.id ? ' active' : ''}`}
                >
                  <p>{exp.name}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

ExploitationHome.propTypes = {
  secteurs: PropTypes.arrayOf(secteurProp),
  setExploitation: PropTypes.func.isRequired,
  exploitation: exploitationProp,
};

export default ExploitationHome;
